/* eslint-disable import/order */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import format from "date-fns/format";
// import CalendarIcon from "../../../assets/svg/Calendar";
import styles from "./DateRangePicker.styles";
// import CalendarIcon from "../../../../../components/Svg/Calendar";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DATE_FORMAT = "dd-MMM-yyyy";
function DateRangePicker({
  label,
  name,
  disabled,
  startDateVal,
  endDateVal,
  onChange,
  customTop,
  customLeft,
}) {
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const toggle = () => setOpen((prev) => !prev);
  const handleSelection = (item) => {
    setSelectedDate([item.selection]);
    if (onChange) {
      onChange(item.selection.startDate, item.selection.endDate);
    }
  };
  const formatStartDate =
    selectedDate[0] && selectedDate[0].startDate
      ? format(selectedDate[0].startDate, DATE_FORMAT)
      : "";
  const formatEndDate =
    selectedDate[0] && selectedDate[0].endDate
      ? format(selectedDate[0].endDate, DATE_FORMAT)
      : "";
  useEffect(() => {
    setSelectedDate(() => [
      {
        key: "selection",
        startDate: startDateVal ? new Date(startDateVal) : null,
        endDate: endDateVal ? new Date(endDateVal) : null,
      },
    ]);
  }, [startDateVal, endDateVal]);
  const isSelected = Boolean(selectedDate[0] && selectedDate[0].endDate);
  const clearSelection = () => {
    setSelectedDate([
      {
        startDate: null,
        endDate: null,
        key: "selection",
      },
    ]);
    if (onChange) {
      onChange(null, null);
    }
  };
  return (
    <div style={{ ...styles.container, ...(disabled ? styles.disabled : {}) }}>
      <div style={styles.input}>
        <div style={styles.inputLabel}>{label}</div>
        <div style={styles.inputValContainer} onClick={!disabled && toggle}>
          <span
            style={{
              ...styles.inputValue,
              ...(isSelected ? styles.selected : {}),
            }}
          >
            {!isSelected
              ? "Date Range (DD-MMM-YYYY)"
              : `${formatStartDate} - ${formatEndDate}`}
          </span>
          {/* <CalendarIcon /> */}
          {isSelected && (
            <IconButton>
              <CloseIcon onClick={clearSelection} style={styles.clearButton} />
            </IconButton>
          )}
        </div>
        {/* {isSelected && (
          <IconButton>
            <CloseIcon onClick={clearSelection} style={styles.clearButton} />
          </IconButton>
        )} */}
      </div>
      {open && (
        <>
          <div
            style={{
              ...styles.datePicker,
              top: customTop !== undefined ? customTop : 53,
              left: customLeft !== undefined ? customLeft : 0,
            }}
          >
            <DateRange
              editableDateInputs
              onChange={handleSelection}
              moveRangeOnFirstSelection={false}
              ranges={selectedDate}
              months={2}
              direction="horizontal"
              style={styles.calendar}
              showDateDisplay={false}
            />
          </div>
          <div style={styles.placeholder} onClick={toggle} />
        </>
      )}
      <input
        type="hidden"
        name={`${name}From`}
        value={formatStartDate}
        readOnly
      />
      <input type="hidden" name={`${name}To`} value={formatEndDate} readOnly />
    </div>
  );
}
export default DateRangePicker;
